var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97957C0 12.3749 3.563 15.9591 7.93219 15.9591C9.72595 15.9591 11.3664 15.3548 12.6923 14.3408L18.011 19.7079C18.1953 19.8933 18.448 19.9968 18.7179 19.9968C19.3051 19.9968 19.6934 19.5522 19.6934 18.9942C19.6934 18.729 19.593 18.4851 19.4101 18.3043L14.1158 12.9507C15.2094 11.5892 15.8643 9.85992 15.8643 7.97957C15.8643 3.58428 12.3014 0 7.93219 0C3.563 0 0 3.58428 0 7.97957ZM1.33232 7.97957C1.33232 4.32108 4.29542 1.33709 7.93219 1.33709C11.569 1.33709 14.532 4.32108 14.532 7.97957C14.532 11.6381 11.569 14.6188 7.93219 14.6188C4.29542 14.6188 1.33232 11.6381 1.33232 7.97957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/searchLight.f487f9730b1d2483cd9ff2cc1cb79e94.svg";
export { ForwardRef as ReactComponent };